import { Route } from '@angular/router';

export const halfItStatisticsRoutes: Route[] = [
    {
        path: 'halve-it/details',
        data: {
            hideTournamentNotification: true,
        },
        loadComponent: () =>
            import('./pages/half-it-statistics-details/half-it-statistics-details.component').then(
                (c) => c.HalfItStatisticsDetailsComponent
            ),
    },
    {
        path: 'halve-it/games/tab/:tab',
        data: {
            hideTournamentNotification: true,
        },
        loadComponent: () =>
            import('./pages/half-it-statistics-games/half-it-statistics-games.component').then(
                (c) => c.HalfItStatisticsGamesComponent
            ),
    },
    {
        path: 'halve-it/games/:id',
        data: {
            hideTournamentNotification: true,
        },
        loadComponent: () =>
            import('./pages/half-it-statistics-games-details/half-it-statistics-games-details.component').then(
                (c) => c.HalfItStatisticsGamesDetailsComponent
            ),
    },
];
